import { fieldRef, constant, agreementRef, op } from './astHelpers';
import { buildPercentageFormula } from './buildPercentageFormula';

/**
 * Capped percentage: MIN(PERCENTAGE(base, rate), cap)
 * Cap may be CONSTANT, AGREEMENT_FIELD, or PERCENTAGE of another base.
 */
export const buildCappedFormula = (cfg = {}) => {
  const pct = buildPercentageFormula(cfg);
  if (!pct) return null;

  let capExpr = null;
  if (cfg.capBaseFieldCode && cfg.capValue != null && cfg.capValue !== '') {
    capExpr = op('PERCENTAGE', [fieldRef(cfg.capBaseFieldCode), constant(cfg.capValue)]);
  } else if (String(cfg.capType || '').toUpperCase() === 'AGREEMENT' && cfg.capValue != null) {
    capExpr = agreementRef(cfg.capBaseFieldCode || 'AGREEMENT_AMOUNT', Number(cfg.capValue) || 0);
  } else if (cfg.capValue != null && cfg.capValue !== '') {
    capExpr = constant(cfg.capValue);
  }

  if (!capExpr) return pct;
  return op('MIN', [pct, capExpr]);
};
